<template>
  <div class="chartheight" ref="chart"></div>
</template>

<script>
export default {
  props: {
    isHaveChildren: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: this.isHaveChildren.haveChildCount,
          name: "是",
          itemStyle: { color: "#7f86ea" },
        },
        {
          value: this.isHaveChildren.noChildCount,
          name: "否",
          itemStyle: { color: "#ff6b6b" },
        },
        {
          value: this.isHaveChildren.noButBuyCount,
          name: "无小孩但有购买需求",
          itemStyle: { color: "#ffb95f" },
        },
        {
          value: this.isHaveChildren.unidentifiedCount,
          name: "未识别",
          itemStyle: { color: "#f3f3f3" },
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
      // this.setOptions(this.sex);
    },
    setOptions(data) {
      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
        },
        legend: {
          bottom: 5,
          icon: "circle",
          data: ["是", "否","无小孩但有购买需求","未识别"],
          itemWidth: 8,
          itemHeight: 8,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: "有无小孩",
          type: "pie",
          radius: ["50%", "65%"],
          avoidLabelOverlap: true,
          label: {
            show: true,
            // formatter: "{b}: {@2012}\n({d}%)",
            formatter:function(params){
              let clientWidth = document.body.clientWidth
              // 根据当前网页的宽度来决定显示文字个数
              let overValue = ''
              if(clientWidth > 1920) {
                overValue += params.name
                overValue += ':'
                overValue += params.value
                overValue += '\n'
                overValue +=  `(${params.percent}%)`
              } else if(1600 < clientWidth && clientWidth < 1920) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,7)
                  overValue += '\n'
                  overValue += params.name.substring(7,params.name.length)
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else if(1420 < clientWidth && clientWidth < 1600) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else if(1220 < clientWidth && clientWidth < 1440) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              }
              return overValue
            },
            color: "#333",
            position: "outer",
            alignTo: "edge",
            margin: 10,
            // position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>


<style scoped lang="scss">
.chartheight {
  height: 300px;
  @media screen and (max-width: 1400px) {
    margin-top: 10px;
    height: 250px;
  }
  @media screen and (max-width: 1340px) {
    margin-top: 10px;
    height: 180px;
  }
}
.order_money {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow: hidden;
  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 24px;
    span {
      color: #2e3458;
      font-size: 16px;
      font-weight: 800;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .content {
    height: 306px;
  }
}
</style>